/**************************************************
 * Nombre:       Home_Proposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from "../../../Recursos/fondo_preguntas.png";
import Tarjeta_Preguntas from "../../Tarjetas/Tarjeta_Preguntas";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Preguntas = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mb: 18}}
            >
                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 8}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                            <Typography sx={{fontSize: sCell ? 28 : 36, fontWeight: 600, textAlign: 'center', lineHeight: 1.1}}>
                                Preguntas Frecuentes
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}/>

                        <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: 'center'}}>
                                Aquí encontrarás respuestas claras a las dudas más comunes sobre BitNova World, su
                                funcionamiento, seguridad y beneficios. Queremos que tomes decisiones informadas y con
                                total confianza.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}/>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={2}
                            >

                                {items.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Preguntas item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Preguntas

const items = [
    {
        nombre: '¿Qué es BitNova World y cómo funciona?',
        descripcion: 'BitNova World es una plataforma que conecta tecnología blockchain con activos físicos y logística global. Permite generar rendimientos diarios mediante estrategias automatizadas y visualizar tus activos en tiempo real dentro de un ecosistema seguro y transparente.'
    },
    {
        nombre: '¿Es necesario tener experiencia previa en criptomonedas para usar BitNova World?',
        descripcion: 'No. BitNova está diseñada para ser intuitiva y accesible tanto para principiantes como para usuarios avanzados. Contamos con herramientas y soporte que te guían en cada paso del proceso.'
    },
    {
        nombre: '¿Cómo se garantiza la seguridad de mis activos?',
        descripcion: 'Utilizamos tecnología blockchain, encriptación avanzada y protocolos de seguridad para proteger tus activos. Además, ofrecemos trazabilidad y reportes en tiempo real para asegurar total transparencia.'
    },
    {
        nombre: '¿Puedo retirar mis rendimientos en cualquier momento?',
        descripcion: 'Los retiros de rendimientos se solicitan los días jueves en el horario establecido, mientras que los bonos pueden retirarse cualquier día.'
    },
    {
        nombre: '¿Puedo usar BitNova World desde cualquier país?',
        descripcion: 'Sí, la plataforma está disponible de manera global y puedes acceder a ella desde cualquier lugar con conexión a internet.'
    },
]